import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs/Subject";
import { HelpersService } from "../helpers/helpers.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Logging } from "../../logging";

@Injectable()
export class AuthService {
  tokenKey: string = "api-token";
  userKey: string = "user";
  loginDetailKey: string = "user-login-details";
  emailappKey: string = "r";
  staffToken: string = "staff-token";
  staffLoginDetailKey: string = "staff-login-details";

  constructor(
    private router: Router,
    private flashMessagesService: FlashMessagesService
  ) {}

  token_set: Subject<any> = new Subject<any>();
  loginDetails_set: Subject<any> = new Subject<any>();
  forcelogout: Subject<any> = new Subject<any>();
  showcount = 0;

  setToken(token: string) {
    sessionStorage.setItem(this.tokenKey, token);
    this.forcelogout.next(false);
  }
  setStaffToken(s_token: string) {
    sessionStorage.setItem(this.staffToken, s_token);
    Logging.log(s_token);
    this.forcelogout.next(false);
  }

  // setStaffToken(token: string){
  //    this.forcelogout.next(false);

  // }

  setApprovalLink(url: string) {
    sessionStorage.setItem(this.emailappKey, url);
  }

  getApprovalLink() {
    return sessionStorage.getItem(this.emailappKey);
  }

  removeApprovalLink() {
    return sessionStorage.removeItem(this.emailappKey);
  }
  getToken() {
    return sessionStorage.getItem(this.tokenKey);
  }

  getStaffToken() {
    return sessionStorage.getItem(this.staffToken);
  }

  setLoginDetails(details: string) {
    sessionStorage.setItem(this.loginDetailKey, JSON.stringify(details));
    this.loginDetails_set.next(true);
  }

  setStaffLoginDetails(s_details: string) {
    sessionStorage.setItem(this.staffLoginDetailKey, JSON.stringify(s_details));
    this.loginDetails_set.next(true);
  }

  getLoginDetails() {
    return JSON.parse(sessionStorage.getItem(this.loginDetailKey));
  }

  getStaffLoginDetails() {
    return JSON.parse(sessionStorage.getItem(this.staffLoginDetailKey));
  }

  getUserID() {
    return this.user() !== null ? this.user().userid : null;
  }

  removeLoginDetails() {
    sessionStorage.removeItem(this.loginDetailKey);
    sessionStorage.removeItem(this.staffLoginDetailKey);
  }

  loginDetailsSet() {
    return this.getLoginDetails() !== null && this.getLoginDetails() !== null;
  }

  isLoggedIn() {
    return this.getToken() !== null && this.user() !== null;
  }

  setUser(user: object) {
    sessionStorage.setItem(this.userKey, JSON.stringify(user));
    this.token_set.next(true);
    this.forcelogout.next(false);
  }

  user() {
    return JSON.parse(sessionStorage.getItem(this.userKey));
  }

  getPermissions() {
    var user = this.user();
    return user.profile.permissions;
  }

  logout() {
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(["/login"]);
    window.location.reload();
  }

  forceLogout() {
    this.forcelogout.next(true);
    this.logout();
  }

  isFullUser() {
    var user = this.user();
    return user.profile.profilename == "Full" ? true : false;
  }

  getAccountID() {
    var user = this.user();
    return user.accountid;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/auth.service.ts